<template>
    <div class="modal-vue mt-3">
        <div class="card">
            <div class="card-header bg-primary">
                <h3> {{ __('message_interface.title') }}</h3>
            </div>
            <div class="card-body">
                <NavTabs :active-tab-index="step"
                         :tabs="tabs"
                         pills
                         fill
                         @selectTab="changeTab">

                    <NavTabContent :title="getTab('step1').title"
                                   :active="getTab('step1').tabIndex == step">
                        <MessageReview :message="message"
                                       @next-tab="step++"
                                       :prev-button="false"
                                       ref="message-review" />
                    </NavTabContent>
                    <NavTabContent :title="getTab('step2').title"
                                   :active="getTab('step2').tabIndex == step"
                                   :disabled="getTab('step2').disabled">
                        <ChooseRecipients @prev-tab="step--"
                                          @next-tab="step++"
                                          :clients="receivers"
                                          :message="message"
                                          @submit-send-message="submitSendMessage" />
                    </NavTabContent>
                    <NavTabContent ::title="getTab('step3').title"
                                   :active="getTab('step3').tabIndex == step"
                                   :disabled="getTab('step3').disabled">
                        <MessageFinish :message="message" />
                    </NavTabContent>
                </NavTabs>
            </div>
        </div>
    </div>
</template>

<script>

import MessageReview from "../../messages/ContactCustomerSteps/MessageReview.vue";
import MessageFinish from "../../messages/ContactCustomerSteps/MessageFinish.vue";
import axios from 'axios';
import NavTabs from "@components/commons/navigation/NavTabs.vue"
import NavTabContent from "@components/commons/navigation/NavTabContent.vue"
import { usePage } from '@inertiajs/vue3'
import ChooseRecipients from "./ChooseRecipients.vue";

const page = usePage()

export default {
    name: 'SendMessage',
    props: ["receivers"],
    components: {
        ChooseRecipients,
        MessageReview,
        MessageFinish,
        NavTabs,
        NavTabContent
    },
    data() {
        return {
            step: 0,
            message: {
                type: 'sms',
                model: 'write',
                messageToSend: "",
                selectedClient: null,
                recipientSelection: '',
                sent: false,
                loading: false,
            },
        }
    },
    computed: {
        tabs() {
            return [
                {
                    title: this.__('message_interface.tabs.step3'),
                    icon: "fa-pen-to-square",
                    step: 'step1',
                    tabIndex: 0
                },
                {
                    title: this.__('message_interface.tabs.choose_recipient'),
                    step: 'step2',
                    icon: "fa-users",
                    disabled: this.message.messageToSend === null || this.message.messageToSend === '' || this.message.sent || this.editableVariablesNumber > 0,
                    tabIndex: 1
                },
                {
                    title: this.__('message_interface.tabs.step5'),
                    step: 'step3',
                    icon: 'fa-paper-plane',
                    disabled: !this.message.sent,
                    tabIndex: 2
                }
            ]
        }
    },
    methods: {
        changeTab(tabIndex) {
            if (!this.getTabByIndex(tabIndex)?.disabled) {

                this.step = tabIndex
            }
        },
        getTabByIndex(tabIndex) {
            return this.tabs.find(x => x.tabIndex == tabIndex)
        },
        getTab(step) {
            return this.tabs.find(x => x.step == step)
        },
        submitSendMessage() {
            this.message.loading = true;
            axios.post('/results/send-message', this.message)
                .then(response => {
                    if (response.status === 200) {
                        this.message.sent = true;
                        this.message.loading = false;
                        this.step = this.getTab('step3')?.tabIndex
                    }
                })
                .catch(error => {
                    this.message.loading = false;
                    this.$toast.open({
                        message: page.props.locale === 'en' ? this.lang.errors.en : this.lang.errors.fr,
                        type: "error",
                        duration: 5000,
                        dismissible: true
                    })
                    console.log(error);
                })
        },
    },

}
</script>
